export enum BotAnswerAnalysis {
    ASSUMPTION = 'assumption',
    ACTION_ANSWER = 'actionAnswer'
}